import dayjs from 'dayjs';

/**
 * Calculates the time difference between two dayjs.Dayjs instances
 * and returns a formatted string in HH:mm format.
 *
 * @param start - The start time as a dayjs object
 * @param end - The end time as a dayjs object
 * @returns The difference formatted as "HH:mm"
 */
export function getTimeDifference(
  start: dayjs.Dayjs | null,
  end: dayjs.Dayjs | null
): string {
  if (!start || !end) {
    return '00:00'; // Return default value if either date is null
  }
  if (start.isAfter(end)) {
    return '00:00'; // Return default value if start date is after end date
  }
  const startTime = start.toDate().getTime();
  const endTime = end.toDate().getTime();
  const diffMilliseconds = endTime - startTime;

  // Calculate hours and minutes
  const diffHours = Math.floor(diffMilliseconds / (1000 * 60 * 60));
  const diffMinutes = Math.floor(
    (diffMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
  );

  // Format as HH:mm
  const diffHoursStr = diffHours.toString().padStart(2, '0');
  const diffMinutesStr = diffMinutes.toString().padStart(2, '0');

  return `${diffHoursStr}:${diffMinutesStr}`;
}